import PurchaseOrderViewDropdown from './PurchaseOrderViewDropdownContainer';

export default PurchaseOrderViewDropdown;
